export default __webpack_public_path__ + "static/rolling_door_w.cd483d4a99feb8fe31910feace47dc9c.png";